import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';

export const GuideQuestSchema = defineSchema({
  name: 'serverGuideQuests',
  fields: [
    ['id', 'number'],
    ['clearCondition', { kind: 'dict', dict: 'clear-condition' }],
    ['rewards', { kind: 'dict', dict: 'delivery' }],
  ],
  lookupKeys: ['id'],
});

export interface RawGuideQuestRow {
  id: number;
  clear_condition: Record<string, unknown>;
  rewards: Record<string, number>;
}

export function guideQuestFromRaw(row: RawGuideQuestRow) {
  return {
    id: row.id,
    clearCondition: row.clear_condition,
    rewards: row.rewards,
  };
}

registerCategorySchema('serverGuideQuests', GuideQuestSchema);
